import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { CopilotType } from 'libs/end-to-end/src/copilot';
import { Card } from 'apps/sigma2-ui/src/components/ui/Card';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';

export const ReadinessRatingTooltip = ({
  show,
  copilotType,
}: {
  show: boolean;
  copilotType: CopilotType;
}) => {
  const language = useLanguage();
  return (
    <>
      {show && (
        <div className="text-gray-700 p-4 w-[100%] flex justify-center absolute bottom-0 left-0 right-0 z-tooltip">
          <div className="flex w-[100%] justify-center">
            <Card className="w-[300px]">
              <Paragraph>
                {copilotType === 'hiring'
                  ? language.hiringCopilotReadinessRatingTooltipText()
                  : language.promotionCopilotReadinessRatingTooltipText()}
              </Paragraph>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};
